// Define an object structure as a "contract"
const ModelHandlerContract = {
    loadModel: () => {},
    predict: (canvas) => {},
    getTotalClasses: () => 0,
  };

export default ModelHandlerContract;